export default __webpack_public_path__ + "static/media/clip_1.8a38e300.jpeg";